import { Component, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { CertificateRequest } from '../../models/certificates/certificateRequest';
import { CertificateResponse } from '../../models/certificates/certificateResponse';
import { CommonIdentificator } from '../../models/certificates/commonIdentificator';

import { CertificateService } from '../../services/certificates/certificate.service';
import { HelperService } from '../../services/common/helper.service';
import { TranslationService } from '../../services/common/translation.service';

@Component({
    selector: 'user-sign-certificate',
    template: require('./../../templates/certificates/certificateForm.component.html'),
    styles: [require('./../../styles/certificates/certificateForms.css')],
    providers: [CertificateService, HelperService, TranslationService]
})
export class CertificateFormComponent {
    generateCert = true;
    certificateRequest: CertificateRequest = new CertificateRequest();
    certificateResponse: CertificateResponse;
    commonIdentificator: CommonIdentificator = {
        commonName: '',
        email: '',
        isValid: false,
        requestLinkId: ''
    };
    @ViewChild('customFile') fileInput: ElementRef;
    fileToUpload: File;
    code: string;
    matchPassword: string;

    isFormValid: boolean;
    isLinkValid: boolean;
    loaded = false;
    errorMessage: string;
    isValid: boolean = true;
    isSuccess: boolean;
    isFail: boolean;

    formSuccess : string;
    formError : string;
    formValidationFailed: string;
    formName: string;
    formEmail: string;
    formConfirm: string;
    formOops: string;
    formVerificationCode: string;
    certificateFormSuccess : string;
    certificateFormSuccessDownload : string;
    certificateFormNotGenerated : string;
    certificateFormNotSigned : string;
    certificateFormInvalidCode : string;
    certificateFormPageTitle : string;
    certificateFormDescription : string;
    certificateFormSelectAction : string;
    certificateFormActionGenerate : string;
    certificateFormActionSign : string;
    certificateFormUploadFile : string;
    certificateFormPassword : string;
    certificateFormPasswordConfirm : string;
    certificateFormPasswordNotMatched : string;
    certificateFormSuccessPart2: string;
    certificateFormUpload: string;
    
    
    constructor(private route: ActivatedRoute, private certificateService: CertificateService, private helperService: HelperService, private translationService: TranslationService) {
        this.code = this.route.snapshot.queryParams.code;

        var result = this.certificateService.isLinkValid(this.code);

        result.subscribe(result => {
            this.loaded = true;
            if (result.success) {
                this.isLinkValid = result.data.isValid;
                if (this.isLinkValid) {
                    this.certificateRequest.authorization.requestLinkId = this.code;
                    this.certificateRequest.authorization.isTokenAuth = false;
                    this.commonIdentificator = result.data;
                }
            } else {
                this.isLinkValid = false;
            }
        });
    }

    ngOnInit() {
        this.initTranslations();
    }

    initTranslations() {
        this.translationService.translate('form.success', 'Success!', (data) => this.formSuccess = data);
        this.translationService.translate('form.error', 'Error!', (data) => this.formError = data);
        this.translationService.translate('form.validationFailed', 'Validation Failed!', (data) => this.formValidationFailed = data);
        this.translationService.translate('form.name', 'Name', (data) => this.formName = data);
        this.translationService.translate('form.email', 'Email', (data) => this.formEmail = data);
        this.translationService.translate('form.confirm', 'Confirm', (data) => this.formConfirm = data);
        this.translationService.translate('form.oops', 'Oops!', (data) => this.formOops = data);
        this.translationService.translate('form.verificationCode', 'Verification Code', (data) => this.formVerificationCode = data);
        this.translationService.translate('certificateForm.success', 'Certificate was successfully signed.', (data) => this.certificateFormSuccess = data);
        this.translationService.translate('certificateForm.successPart2', 'If download has not started automatically', (data) => this.certificateFormSuccessPart2 = data);
        this.translationService.translate('certificateForm.successDownload', 'you can download it here.', (data) => this.certificateFormSuccessDownload = data);
        this.translationService.translate('certificateForm.notGenerated', 'New certificate wasn\'t generated.', (data) => this.certificateFormNotGenerated = data);
        this.translationService.translate('certificateForm.notSigned', 'Certificate wasn\'t signed.', (data) => this.certificateFormNotSigned = data);
        this.translationService.translate('certificateForm.invalidCode', 'Code you\'ve provided has expired or is not valid.', (data) => this.certificateFormInvalidCode = data);
        this.translationService.translate('certificateForm.pageTitle', 'Certificate Management', (data) => this.certificateFormPageTitle = data);
        this.translationService.translate('certificateForm.description', 'Here you can get your certificate signed or download new signed certificate assigned to your account.', (data) => this.certificateFormDescription = data);
        this.translationService.translate('certificateForm.selectAction', 'Select action', (data) => this.certificateFormSelectAction = data);
        this.translationService.translate('certificateForm.actionGenerate', 'Generate new Certificate', (data) => this.certificateFormActionGenerate = data);
        this.translationService.translate('certificateForm.actionSign', 'Sign existing Certificate', (data) => this.certificateFormActionSign = data);
        this.translationService.translate('certificateForm.uploadFile', 'Upload your Certificate Sign Request', (data) => this.certificateFormUploadFile = data);
        this.translationService.translate('certificateForm.password', 'Certificate Password', (data) => this.certificateFormPassword = data);
        this.translationService.translate('certificateForm.passwordConfirm', 'Confirm Certificate Password', (data) => this.certificateFormPasswordConfirm = data);
        this.translationService.translate('certificateForm.passwordNotMatched', 'Passwords do not match!', (data) => this.certificateFormPasswordNotMatched = data);
        this.translationService.translate('certificateForm.certificateFormUpload', 'Browse', (data) => this.certificateFormUpload = data);
    }

    public confirm() {
        this.loaded = false;
        this.isSuccess = false;
        this.isFail = false;
        this.errorMessage = '';

        this.isValid = this.validate();
        if (this.isValid) {
            this.certificateRequest.content.isCertSignRequest = !this.generateCert;

            if (this.generateCert) {
                this.certificateRequest.content.fileBase64Value = '';
                this.certificateRequest.content.fileName = '';

                var result = this.certificateService.requestCertificate(this.certificateRequest);
            } else {
                this.certificateRequest.content.exportPassword = '';
                this.matchPassword = '';

                var result = this.certificateService.signCertificate(this.certificateRequest);
            }

            result.subscribe(result => {
                this.loaded = true;

                if (result.success) {
                    this.isSuccess = true;
                    this.certificateResponse = result.data;
                    this.downloadFile();
                } else {
                    this.isFail = true;
                    this.isValid = false;
                    if (result.errors != null) {
                        result.errors.forEach((value) => {
                            this.addError(value.code, value.description, value.values);
                        });
                    }
                }
            });
        } else {
            this.loaded = true;
        }
    }

    public validate() {
        this.isFormValid = true;
        this.errorMessage = '';
        if (this.helperService.isNullOrEmpty(this.certificateRequest.authorization.verificationCode)) {
            this.addError('certificateForm.verificationCodeEmpty', 'Verification code can\'t be empty', new Array<string>());
            this.isFormValid = false;
        }
        if (!this.generateCert && (this.helperService.isNullOrEmpty(this.certificateRequest.content.fileBase64Value) || this.helperService.isNullOrEmpty(this.certificateRequest.content.fileName))) {
            this.addError('certificateForm.certificateMissing', 'Certificate must be uploaded', new Array<string>());
            this.isFormValid = false;
        }
        if (this.generateCert && this.helperService.isNullOrEmpty(this.certificateRequest.content.exportPassword)) {
            this.addError('certificateForm.passwordEmpty', 'Export password can\'t be empty', new Array<string>());
            this.isFormValid = false;
        }
        if (this.generateCert && this.certificateRequest.content.exportPassword.length < 3) {
            this.addError('certificateForm.exportPasswordShort', 'Export password must have at least <strong>3</strong> characters', new Array<string>());
            this.isFormValid = false;
        }
        if (!this.match()) {
            this.addError('certificateForm.passwordNotMatched', 'Passwords do not match!', new Array<string>());
            this.isFormValid = false;
        }
        return this.isFormValid;
    }

    public handleFileInput(event:any) {
        let reader = new FileReader();

        if (event.target.files && event.target.files.length > 0) {
            this.fileToUpload = event.target.files[0];
            reader.readAsDataURL(this.fileToUpload);
            reader.onload = () => {
                this.certificateRequest.content.fileName = this.fileToUpload.name;
                this.certificateRequest.content.fileBase64Value = reader.result.split(',')[1];
            };
        }
    }

    public openFileDialog() {
        let event = new MouseEvent('click', { bubbles: false });
        this.fileInput.nativeElement.dispatchEvent(event);
    }

    public match() {
        if (!this.generateCert) {
            return true;
        }
        return this.matchPassword != '' && this.matchPassword == this.certificateRequest.content.exportPassword;
    }

    private addError(code: string, error: string, args: string[]) {
        this.translationService.translate(code, error, (data) => this.errorMessage += '<br /> ' + this.helperService.format(data, args));
    }

    public downloadFile() {
        if (this.certificateResponse.isSignRequest) {
            this.download('certificate.crt', this.certificateResponse.certificate);
        } else {
            this.download('certificate.pfx', this.certificateResponse.certificate);
        }
        
    }

    private download(filename: string, text: string) {
        var blob = new Blob([this.convertBase64ToArrayBuffer(text)], { type: 'application/x-pkcs12' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
            var data = window.URL.createObjectURL(blob);
            var element = document.createElement('a');
            element.setAttribute('href', data);
            element.setAttribute('download', filename);

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();
            document.body.removeChild(element);
        }
    }

    private convertBase64ToArrayBuffer(base64: string) {
        var binaryString = window.atob(base64);
        var length = binaryString.length;
        var bytes = new Uint8Array(length);
        for (var i = 0; i < length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes.buffer;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/components/certificates/certificateForm.component.ts